import { loadFileAsUint8Array, zstdDecompressString } from "./funcZstd";
import { load as loadYAML } from "js-yaml";
export class ItemData {
    constructor(parameter) {
        this.parameter = parameter;
    }
    getId() {
        return this.parameter.id;
    }
    getIdNum() {
        return this.parameter.id; // getId()のエイリアス
    }
    getDisplayName() {
        return this.parameter.displayname;
    }
    getDescription() {
        return this.parameter.description;
    }
    isCard() {
        return this.parameter.is_card;
    }
    isEnchant() {
        return this.parameter.is_enchant;
    }
    getResName() {
        return this.parameter.resname;
    }
    getType() {
        return this.parameter.type;
    }
    getSlot() {
        return this.parameter.slot;
    }
}
export class ItemMap {
    /** 全てのアイテムを取得 */
    static getAll() {
        return Object.entries(this.itemMap).map(([key, value]) => [Number(key), value]);
    }
    /** id から Item を取得 */
    static getById(id) {
        const itemParam = this.itemMap[id];
        return itemParam !== undefined ? new ItemData(itemParam) : undefined;
    }
    /** displayname から Item を取得 */
    static getByDisplayName(displayName) {
        for (const item of Object.values(this.itemMap)) {
            if (item.displayname === displayName) {
                return new ItemData(item);
            }
            else {
                //名前の揺らぎ考慮
                if (displayName.match(/[\+\-]/) && item.displayname === displayName.replace(/\+/g, ' + ').replace(/\-/g, ' - ')) {
                    return new ItemData(item);
                }
            }
        }
        return undefined;
    }
    /* migId から Id を取得 */
    static findItemByMigIdFromItem(migId) {
        const itemObject = ItemObjNew[migId];
        if (!itemObject)
            return undefined;
        const displayName = itemObject[8];
        return this.getByDisplayName(displayName);
    }
    /* migId から Id を取得 */
    static findItemByMigIdFromCardOrEnchant(migId, is_enchant = false) {
        const itemObject = CardObjNew[migId];
        if (!itemObject) {
            console.warn(`Item not found for migId: ${migId}`);
            return undefined;
        }
        let displayName = itemObject[2];
        if (is_enchant === false && displayName.match(/カード/) === null) {
            displayName += 'カード';
        }
        else {
            displayName = displayName.replace(/^(Special)(.+)$/, '$1 $2'); //間にスペース
            displayName = displayName.replace(/^(Extra)(.+)$/, '$1 $2'); //間にスペース
        }
        return this.getByDisplayName(displayName);
    }
    /** アイテムデータをロード */
    static async load() {
        const compressed = await loadFileAsUint8Array('../../dist/item.yaml.zst');
        const itemLines = await zstdDecompressString(compressed) || "";
        try {
            // YAMLとしてロード
            this.itemMap = loadYAML(itemLines);
        }
        catch (err) {
            console.error('YAML load error:', err);
        }
    }
    /** ロード完了か確認 **/
    static async isLoaded() {
        return Object.keys(this.itemMap).length > 0;
    }
}
ItemMap.itemMap = {};
window.ItemMap = ItemMap; // グローバルに登録
